import './DatasetMasterSearch.css';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Image from 'react-bootstrap/Image';


function DatasetMasterSearch(props) {

    const { metadata, onChange, clearSearch, searchText, searchPlaceholder } = props;

    return (
        <div style={{marginBottom: '2em', textAlign: 'center'}}>
            <Form style={{paddingTop: '1em', marginBottom: '0.5em' }}>
                <div style={{width: '100%'}}>
                    <Image
                        src="HSEO_logo-color.png"
                        fluid={true}
                        style={{
                            display: 'inline-block', maxWidth: '10%', height: 'auto',
                            minWidth: 64, minHeight: 'auto',
                            background: '#fff', marginRight: '1em', padding: '0.5em'
                        }}
                    ></Image>
                    <i className='las la-search search-icon'></i>&nbsp;
                    <Form.Control
                        onChange={onChange}
                        size="md"
                        value={searchText}
                        id='master-search-bar' type='text'
                        disabled={metadata.length === 0}
                        className='datasets-search-bar' placeholder={searchPlaceholder}
                    />
                    {
                        metadata.length === 0 &&
                        <div style={{ marginLeft: '0.6em', display: 'inline', color: '#fff' }}>
                            <p style={{fontWeight: 'bold', display: 'inline', fontSize: '0.75em'}}>Loading ...</p>
                            <Spinner style={{marginLeft: '0.6em'}} animation="grow" size="sm" />
                        </div>
                    }
                    {
                        searchText !== '' &&
                        <Button 
                            style={{marginLeft: '0.6em', fontSize: '0.7em'}} variant="outline-light"
                            className="clear-button" 
                            size="md" onClick={clearSearch}
                        >
                            <p className='clear-button-text'>Clear</p>&nbsp;&nbsp;
                            <i className="las la-times-circle" />
                        </Button>
                    }
                </div>
            </Form>
        </div>
    );
}

export default DatasetMasterSearch;